<template>
  <b-dropdown
    :data-testing="dataTesting"
    class="user-preview"
    no-caret
    toggle-class="user-preview__toggle"
  >
    <template #button-content>
      <p class="user-preview__info">
        <span
          class="user-preview__username"
          v-text="user.full_name"
        />
        <span
          class="user-preview__organisation"
          v-text="user.account.company_name"
        />
      </p>
      <span class="user-preview__caret" />
    </template>
    <b-dropdown-item
      v-for="(item, index) in actionItems"
      :key="index"
      class="user-preview__action"
      href="#"
      @click.prevent="onClickAction(item.action)"
    >
      {{ $t(item.label) }}
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
import { BDropdown, BDropdownItem } from 'bootstrap-vue';

export default {
  name: 'UserPreview',
  components: {
    BDropdown,
    BDropdownItem
  },
  props: {
    /**
     * Array of action action items
     */
    actionItems: {
      type: Array,
      required: true
    },
    user: {
      type: Object,
      default: null,
      required: true
    },
    /**
     * Variable for cypress testing
     */
    dataTesting: {
      type: String,
      default: null
    }
  },
  methods: {
    /**
     * Emits actions to parent component.
     * @event onClickAction
     * @type {Click}
     */
    onClickAction(action) {
      this.$emit(action);
    }
  }
};
</script>

<style lang="scss">
  @import './UserPreview';
</style>
